import { Box, styled } from '@mui/material';
export default styled(Box)(() => ({
    flexGrow: 1,
    overflow: 'auto',
}));
